export function removeTrailingSlash(url) {
    return url.endsWith('/') ? url.slice(0, -1) : url;
}

//# sourceMappingURL=url-remove-trailing-slash.js.map